import type { SVGProps } from "react";

const SvgN26SmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 423.99 424"
    {...props}
  >
    <defs>
      <clipPath id="n26_de_svg__a">
        <path d="M0 0h423.988v424H0zm0 0" />
      </clipPath>
    </defs>
    <g clipPath="url(#n26_de_svg__a)">
      <path
        fill="#44ac99"
        d="M423.992 338.148c0 47.414-38.433 85.852-85.851 85.852H85.848C38.438 424 0 385.562 0 338.148V85.852C0 38.437 38.438 0 85.848 0H338.14c47.418 0 85.851 38.438 85.851 85.852v252.296"
      />
    </g>
    <path
      fill="#fff"
      d="M329.395 265.055c-14.758 0-24.977-13.559-26.743-31.563 4.48-15.351 14.418-23.004 26.172-23.004 15.106 0 23.63 11.157 23.63 27.016 0 17.023-9.72 27.55-23.06 27.55zm3.699-69.43c-14.918 0-25.567 6.898-30.946 17.11 0-24.133 8.407-45.137 28.387-45.137 12.703 0 17.742 7.304 20.438 19.289l18.5-3.703c-4.34-20.688-17.5-30.743-38.805-30.743-26.77 0-46.797 20.555-46.797 66.621 0 40.895 16.7 61.11 45.477 61.11 23.777 0 41.586-16.238 41.586-42.996 0-20.903-11.145-41.551-37.84-41.551M202.082 262.64c9.418-6.507 22.918-17.32 28.906-23.32 6.813-6.808 26.196-24.316 26.196-49.28 0-25.798-16.813-37.606-39.551-37.606-27.563.007-41.168 16.972-41.168 36.379a39.7 39.7 0 0 0 1.23 9.878l18.883 1.817a50 50 0 0 1-1.23-10.746c0-14.532 9.617-21.489 21.66-21.489 11.738 0 20.43 6.579 20.43 22.399 0 16.074-7.864 27.031-19.836 39.02-12.52 12.527-32.532 27.476-42.172 34.347v14.809h83.156V262.64zm-55.668 48.622v16.203H45.543v-16.203zm0-206.117v16.207H45.543v-16.207zm-18.898 48.617v85.57c0 7.574.171 12.156.527 16.563h-.356c-1.851-5.043-4.035-9.465-7.289-15.22L69.79 153.763H46.656v125.086H64.68V193.27c0-7.579-.176-12.157-.524-16.563h.371c1.848 5.043 4.032 9.461 7.29 15.211l50.593 86.93h22.887V153.762z"
    />
  </svg>
);
export default SvgN26SmallLogo;
